module.exports = __webpack_public_path__ + "media/images/doctor-day/doctorday-template-ru-968771035e315639a6e937e591439f18.png";